export default __webpack_public_path__ + "static/media/direct_print2.461a3b63.svg";